import React from 'react';
import './DashedStepper.css';

const superAdminSteps = ['Step 1', 'Step 2', 'Step 3', 'Step 4', 'Step 5'];
const userSteps = ['Step 1', 'Step 2'];
const DashedStepper = ({ activeStep = 0 }) => {
  const authData = localStorage.getItem('@auth_login');
  const userData = JSON.parse(authData);
  // console.log("user data from the localhost",userData);
  return (
    <div className="stepper-container">
      {userData?.data?.userType == 'b2b' ? superAdminSteps.map((step, index) => (
        <div className="step-wrapper" key={index}>

          {index !== superAdminSteps.length && (
            <div className={`step-line ${index < activeStep ? 'completed' : ''}`} />
          )}
        </div>
      )) : userSteps.map((step, index) => (
        <div className="step-wrapper" key={index}>

          {index !== userSteps.length && (
            <div className={`step-line ${index < activeStep ? 'completed' : ''}`} />
          )}
        </div>
      ))}
    </div>
  );
};

export default DashedStepper;
